module.exports = __webpack_public_path__ + "99bd4b186d4bf84828daaa5a8fe10c9f.png";